import { render, staticRenderFns } from "./Understanding.vue?vue&type=template&id=e4f20682&scoped=true&"
import script from "./Understanding.vue?vue&type=script&lang=js&"
export * from "./Understanding.vue?vue&type=script&lang=js&"
import style0 from "./Understanding.vue?vue&type=style&index=0&id=e4f20682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f20682",
  null
  
)

export default component.exports